<template>
  <ProvideStateTriggeredByMouseEvents v-slot="{ isActivated, activationEvents }">
    <span v-on="activationEvents">
      <component
        v-bind="$attrs"
        :is="isActivated ? componentNameWhenActive : 'empty-slot-renderer'"
        :slot-name-to-render="isActivated ? null : slotToRenderWhenInactive"
      >
        <!-- eslint-disable-next-line vue/no-v-for-template-key -- Baseline eslint ignore please fix if working on this-->
        <template v-for="name in Object.keys($slots)" :key="name" #[name]="data">
          <!-- The deconstruction of data handles undefined and null values-->
          <slot v-bind="{ ...data }" :name="name"></slot>
        </template>
      </component>
    </span>
  </ProvideStateTriggeredByMouseEvents>
</template>

<script>
import ProvideStateTriggeredByMouseEvents from '@/components/ProvideStateTriggeredByMouseEvents.vue'
import EmptySlotRenderer from '@/components/EmptySlotRenderer.vue'

/**
 * Renders a slot (default, or named) until such time as the component is hovered
 * Once hovered, the component will transform into the component dictated by componentNameWhenActive
 * This saves resources when very many components are being instantiated (i.e. lists, tables)
 * - All slot props and regular attributes provided to ghost-component will
 * be passed to the desired component once hovered
 */
export default {
  components: { ProvideStateTriggeredByMouseEvents, EmptySlotRenderer },
  props: {
    componentNameWhenActive: {
      type: String,
      required: true,
    },
    slotToRenderWhenInactive: {
      type: String,
      default: 'default',
    },
  },
}
</script>

<style scoped></style>
